import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { honestFAQ } from "@/mocks/faq";
import { useTranslation } from "react-i18next";

export default function Honesty() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { t } = useTranslation();

  const hardTruths = [
    { title: t("honesty.truth1Title"), body: t("honesty.truth1Body") },
    { title: t("honesty.truth2Title"), body: t("honesty.truth2Body") },
    { title: t("honesty.truth3Title"), body: t("honesty.truth3Body") },
    { title: t("honesty.truth4Title"), body: t("honesty.truth4Body") },
  ];

  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <main className="pt-24 md:pt-32 pb-20">
        <div className="w-full px-4 md:px-8 lg:px-12 mb-16 md:mb-24">
          <div className="max-w-3xl">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">{t("honesty.sectionLabel")}</p>
            <h1 className="font-serif text-4xl md:text-5xl font-semibold text-ink mb-6 leading-tight">{t("honesty.title")}</h1>
            <p className="text-lg text-ink/50 font-light max-w-2xl leading-relaxed">{t("honesty.intro")}</p>
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-12 mb-20">
          <div className="max-w-3xl mx-auto">
            {honestFAQ.map((item, idx) => (
              <div key={idx} className="border-b border-hairline">
                <button
                  onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                  className="w-full flex items-start justify-between gap-4 py-6 text-left cursor-pointer group">
                  <span className="font-serif text-lg md:text-xl font-medium text-ink group-hover:text-gold transition-colors">
                    {item.question}
                  </span>
                  <i className={`ri-add-line text-xl text-ink/30 mt-1 transition-transform duration-300 flex-shrink-0 ${openIndex === idx ? "rotate-45" : ""}`}></i>
                </button>
                <div className={`overflow-hidden transition-all duration-500 ${openIndex === idx ? "max-h-96 pb-6" : "max-h-0"}`}>
                  <p className="text-sm md:text-base text-ink/60 leading-relaxed font-light">{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-12 mb-20">
          <div className="max-w-3xl mx-auto">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-8">{t("honesty.moreTruths")}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {hardTruths.map((item) => (
                <div key={item.title} className="bg-white border border-hairline p-6">
                  <h4 className="font-serif text-base font-semibold text-ink mb-2">{item.title}</h4>
                  <p className="text-sm text-ink/50 leading-relaxed font-light">{item.body}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto bg-ink p-8 md:p-10">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">{t("honesty.disclaimerLabel")}</p>
            <p className="text-sm text-paper/50 leading-relaxed font-light">{t("honesty.disclaimerText")}</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}